import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface AcceptChallengeData {
  challengeId: string;
  identityId: string;
  otpCode: string;
  email: string;
}

export interface AcceptChallengeTokenData {
  acceptOptions: {
    tokenOption: {
      tokenReference: string;
    };
  };
}

// Define schema that matches AcceptChallengeResponse
const acceptChallengeResponseSchema = z.object({
  challengeVerified: z.boolean().optional(),
  errorMessage: z.string().optional(),
  acceptChallengeId: z.string().optional(),
  challengeContext: z.string().optional(),
  title: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  message: z.string().optional(),
  version: z.string().optional(),
});

// Extract type from schema
export type AcceptChallengeResponse = z.infer<
  typeof acceptChallengeResponseSchema
>;

export default async function fetchAcceptChallenge(
  lambdaUrl: string,
  data: AcceptChallengeData | AcceptChallengeTokenData,
  headers: Headers,
) {
  const response = await unauthenticatedFetch(`${lambdaUrl}/accept-challenge`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(data),
    headers,
  });

  const result: unknown = await response.json();
  return acceptChallengeResponseSchema.parse(result);
}
